module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Unsubscribe',
        unsubscribeSubHeader: 'Unsubscribe from your subscription?',
        youHaveSaved: 'you have saved',
        since: 'since',
        youWillSave: 'You will save',
        nextYear: 'in the next year with this subscription.',
        qty: 'Qty',
        yearlySavings: 'yearly savings',
        nevermindCTA: 'Nevermind',
        unsubscribeCTA: 'Unsubscribe',
        item: `ITEM ${vars[0]}`,
        skipNextDelivery: 'Skip Next Delivery Instead'
    };

    return resources[label];
};
